import { createDeferred } from '.';

export class ScriptLoader {
  private isInjected = false;
  private deferred = createDeferred<void, Error>();

  constructor(private readonly url: string) {}

  public isLoaded(): boolean {
    return this.deferred.isResolved;
  }

  public async load(): Promise<void> {
    if (!this.isInjected) {
      const scriptTag = document.createElement('script');

      scriptTag.src = this.url;
      scriptTag.async = true;
      scriptTag.defer = true;

      // Script life-cycle handling
      scriptTag.onload = () => this.deferred.resolve();
      scriptTag.onerror = () => this.deferred.reject(new Error(`Couldn't load: ${this.url}`));

      // Inject
      document.body.appendChild(scriptTag);
      this.isInjected = true;
    }

    return this.deferred.promise;
  }
}
